import type { ItemListSummaryRow } from "../types/listItemSummary"

/** 50 baris dummy — sama dengan referensi HTML */
export const DUMMY_ITEM_LIST_SUMMARY_ROWS: ItemListSummaryRow[] = [
  {
    itemCode: "ITM-0001",
    itemName: "Velvet Cushion Cover Luxe 50x30 Blush",
    category: "Cushion Cover",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 80,
    avgCost: 90666,
    lastPrice: 85000,
    sellingPrice: 490000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0002",
    itemName: "Fabric Tenun Traditional Natural",
    category: "RM - Fabric",
    location: "Production",
    uom: "MTR",
    soh: 46,
    avgCost: 105000,
    lastPrice: 105000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0003",
    itemName: "Macrame Sewing Fancy Moss",
    category: "SRV - Sewing",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 0,
    avgCost: 0,
    lastPrice: 48000,
    sellingPrice: 0,
    stockStatus: "Out of Stock",
    movementStatus: "No Movement"
  },
  {
    itemCode: "ITM-0004",
    itemName: "Hamman Face Wash Natural",
    category: "Hamman",
    location: "Retail Store",
    uom: "PCS",
    soh: 0,
    avgCost: 0,
    lastPrice: 0,
    sellingPrice: 95000,
    stockStatus: "Out of Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0005",
    itemName: "Linen Bed Runner Sumba Pattern",
    category: "Finished Goods",
    location: "Retail Store",
    uom: "PCS",
    soh: 12,
    avgCost: 175000,
    lastPrice: 185000,
    sellingPrice: 420000,
    stockStatus: "Low Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0006",
    itemName: "Amenities Kit Bamboo Tray",
    category: "Amenities",
    location: "Resort Store",
    uom: "SET",
    soh: 155,
    avgCost: 65000,
    lastPrice: 62000,
    sellingPrice: 125000,
    stockStatus: "Overstock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0007",
    itemName: "Organic Coffee 250gr Premium",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PCS",
    soh: 34,
    avgCost: 42000,
    lastPrice: 42000,
    sellingPrice: 95000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0008",
    itemName: "Project Cement Type A",
    category: "Project Material",
    location: "Project Site",
    uom: "BAG",
    soh: 220,
    avgCost: 72000,
    lastPrice: 72000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0009",
    itemName: "LED Bulb Warm White 12W",
    category: "Spare Parts",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 6,
    avgCost: 28000,
    lastPrice: 30000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0010",
    itemName: "Cotton Towel Resort White",
    category: "Consumables",
    location: "Resort Store",
    uom: "PCS",
    soh: 420,
    avgCost: 55000,
    lastPrice: 54000,
    sellingPrice: 0,
    stockStatus: "Overstock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0011",
    itemName: "Ceramic Plate Handmade White",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 28,
    avgCost: 120000,
    lastPrice: 115000,
    sellingPrice: 275000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0012",
    itemName: "Wooden Lamp Base Natural",
    category: "Finished Goods",
    location: "Main Warehouse",
    uom: "PCS",
    soh: -2,
    avgCost: 220000,
    lastPrice: 215000,
    sellingPrice: 590000,
    stockStatus: "Negative Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0013",
    itemName: "Spa Oil Lemongrass 1L",
    category: "Consumables",
    location: "Resort Store",
    uom: "BTL",
    soh: 18,
    avgCost: 95000,
    lastPrice: 98000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0014",
    itemName: "Rattan Basket Oval Medium",
    category: "Retail Product",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 65,
    avgCost: 88000,
    lastPrice: 90000,
    sellingPrice: 240000,
    stockStatus: "In Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0015",
    itemName: "Outdoor Cushion Waterproof Grey",
    category: "Cushion Cover",
    location: "Retail Store",
    uom: "PCS",
    soh: 8,
    avgCost: 150000,
    lastPrice: 145000,
    sellingPrice: 395000,
    stockStatus: "Low Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0016",
    itemName: "Guest Slipper Natural",
    category: "Amenities",
    location: "Resort Store",
    uom: "PAIR",
    soh: 300,
    avgCost: 12000,
    lastPrice: 12500,
    sellingPrice: 0,
    stockStatus: "Overstock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0017",
    itemName: "Teak Dining Chair Natural",
    category: "Finished Goods",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 9,
    avgCost: 750000,
    lastPrice: 780000,
    sellingPrice: 1850000,
    stockStatus: "In Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0018",
    itemName: "Mosquito Spray Eco 500ml",
    category: "Consumables",
    location: "Resort Store",
    uom: "BTL",
    soh: 4,
    avgCost: 35000,
    lastPrice: 36000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0019",
    itemName: "Handwoven Throw Blanket Indigo",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 17,
    avgCost: 210000,
    lastPrice: 205000,
    sellingPrice: 690000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0020",
    itemName: "Old Pattern Fabric Clearance",
    category: "RM - Fabric",
    location: "Main Warehouse",
    uom: "MTR",
    soh: 95,
    avgCost: 67000,
    lastPrice: 65000,
    sellingPrice: 0,
    stockStatus: "Dead Stock",
    movementStatus: "No Movement"
  },
  {
    itemCode: "ITM-0021",
    itemName: "Handmade Soap Lemongrass",
    category: "Amenities",
    location: "Resort Store",
    uom: "PCS",
    soh: 185,
    avgCost: 18000,
    lastPrice: 17500,
    sellingPrice: 45000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0022",
    itemName: "Bath Robe Premium Cotton",
    category: "Consumables",
    location: "Resort Store",
    uom: "PCS",
    soh: 42,
    avgCost: 185000,
    lastPrice: 190000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0023",
    itemName: "Woven Basket Small Natural",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 75,
    avgCost: 45000,
    lastPrice: 48000,
    sellingPrice: 125000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0024",
    itemName: "Stoneware Mug Sand Color",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 31,
    avgCost: 65000,
    lastPrice: 64000,
    sellingPrice: 165000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0025",
    itemName: "Wall Decor Sumba Motif",
    category: "Finished Goods",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 11,
    avgCost: 320000,
    lastPrice: 315000,
    sellingPrice: 850000,
    stockStatus: "Low Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0026",
    itemName: "Laundry Chemical 20L",
    category: "Consumables",
    location: "Resort Store",
    uom: "GAL",
    soh: 9,
    avgCost: 260000,
    lastPrice: 255000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0027",
    itemName: "Pool Towel Blue Stripe",
    category: "Consumables",
    location: "Resort Store",
    uom: "PCS",
    soh: 140,
    avgCost: 78000,
    lastPrice: 80000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0028",
    itemName: "Restaurant Napkin Linen",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PCS",
    soh: 260,
    avgCost: 18000,
    lastPrice: 18500,
    sellingPrice: 0,
    stockStatus: "Overstock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0029",
    itemName: "Bamboo Straw Pack",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PACK",
    soh: 32,
    avgCost: 22000,
    lastPrice: 21000,
    sellingPrice: 55000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0030",
    itemName: "Mini Bar Glass Bottle 330ml",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PCS",
    soh: 0,
    avgCost: 7000,
    lastPrice: 7500,
    sellingPrice: 15000,
    stockStatus: "Out of Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0031",
    itemName: "Plywood Marine Grade 18mm",
    category: "Project Material",
    location: "Project Site",
    uom: "SHEET",
    soh: 38,
    avgCost: 310000,
    lastPrice: 305000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0032",
    itemName: "Paint Outdoor White 20L",
    category: "Project Material",
    location: "Project Site",
    uom: "PAIL",
    soh: 5,
    avgCost: 680000,
    lastPrice: 690000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0033",
    itemName: "PVC Pipe 2 Inch",
    category: "Spare Parts",
    location: "Project Site",
    uom: "PCS",
    soh: 88,
    avgCost: 24000,
    lastPrice: 25000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0034",
    itemName: "Water Pump Filter Cartridge",
    category: "Spare Parts",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 3,
    avgCost: 175000,
    lastPrice: 180000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0035",
    itemName: "Emergency Flashlight Rechargeable",
    category: "Spare Parts",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 16,
    avgCost: 135000,
    lastPrice: 132000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0036",
    itemName: "First Aid Kit Standard",
    category: "Amenities",
    location: "Resort Store",
    uom: "SET",
    soh: 7,
    avgCost: 210000,
    lastPrice: 215000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0037",
    itemName: "Yoga Mat Natural Rubber",
    category: "Retail Product",
    location: "Resort Store",
    uom: "PCS",
    soh: 24,
    avgCost: 155000,
    lastPrice: 160000,
    sellingPrice: 390000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0038",
    itemName: "Essential Oil Lavender 30ml",
    category: "Retail Product",
    location: "Retail Store",
    uom: "BTL",
    soh: 52,
    avgCost: 38000,
    lastPrice: 39000,
    sellingPrice: 125000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0039",
    itemName: "Incense Holder Ceramic",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 44,
    avgCost: 32000,
    lastPrice: 33000,
    sellingPrice: 95000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0040",
    itemName: "Table Runner Handwoven Red",
    category: "Finished Goods",
    location: "Retail Store",
    uom: "PCS",
    soh: 14,
    avgCost: 145000,
    lastPrice: 150000,
    sellingPrice: 375000,
    stockStatus: "In Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0041",
    itemName: "Candle Holder Teak Small",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 63,
    avgCost: 42000,
    lastPrice: 43000,
    sellingPrice: 125000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0042",
    itemName: "Resort Room Key Tag Wood",
    category: "Amenities",
    location: "Resort Store",
    uom: "PCS",
    soh: 18,
    avgCost: 22000,
    lastPrice: 23000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0043",
    itemName: "Blackout Curtain Linen Beige",
    category: "Finished Goods",
    location: "Main Warehouse",
    uom: "SET",
    soh: 6,
    avgCost: 480000,
    lastPrice: 495000,
    sellingPrice: 1250000,
    stockStatus: "Low Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0044",
    itemName: "Decorative Pillow Inner 50x50",
    category: "Cushion Cover",
    location: "Main Warehouse",
    uom: "PCS",
    soh: 115,
    avgCost: 60000,
    lastPrice: 62000,
    sellingPrice: 0,
    stockStatus: "Overstock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0045",
    itemName: "Serving Tray Rattan Large",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 21,
    avgCost: 98000,
    lastPrice: 100000,
    sellingPrice: 280000,
    stockStatus: "In Stock",
    movementStatus: "Fast Moving"
  },
  {
    itemCode: "ITM-0046",
    itemName: "Kitchen Apron Linen Natural",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PCS",
    soh: 15,
    avgCost: 75000,
    lastPrice: 77000,
    sellingPrice: 0,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0047",
    itemName: "Chef Knife Stainless 8 Inch",
    category: "Food & Beverage",
    location: "Resort Store",
    uom: "PCS",
    soh: 2,
    avgCost: 320000,
    lastPrice: 330000,
    sellingPrice: 0,
    stockStatus: "Low Stock",
    movementStatus: "Slow Moving"
  },
  {
    itemCode: "ITM-0048",
    itemName: "Solar Garden Lamp Warm",
    category: "Spare Parts",
    location: "Project Site",
    uom: "PCS",
    soh: 0,
    avgCost: 145000,
    lastPrice: 150000,
    sellingPrice: 0,
    stockStatus: "Out of Stock",
    movementStatus: "No Movement"
  },
  {
    itemCode: "ITM-0049",
    itemName: "Handmade Ceramic Bowl Large",
    category: "Retail Product",
    location: "Retail Store",
    uom: "PCS",
    soh: 19,
    avgCost: 115000,
    lastPrice: 118000,
    sellingPrice: 320000,
    stockStatus: "In Stock",
    movementStatus: "Normal Moving"
  },
  {
    itemCode: "ITM-0050",
    itemName: "Archive Fabric Collection 2024",
    category: "RM - Fabric",
    location: "Main Warehouse",
    uom: "MTR",
    soh: 180,
    avgCost: 52000,
    lastPrice: 50000,
    sellingPrice: 0,
    stockStatus: "Dead Stock",
    movementStatus: "No Movement"
  }
]
